module.exports = __webpack_public_path__ + "static/media/CAD-1.1b62f225.png";